import { Outlet } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';

/**
 * Shared chrome for every authenticated providers route: `Navigation`, plus the `pb-20 lg:pb-0`
 * clearance that keeps content clear of `Navigation`'s fixed mobile tab bar (see that component's
 * own comment on the bar). Providers has no `Footer` today. Mounted once as a layout route in
 * `App.tsx` — pages render only their own content into the `<Outlet/>` and no longer paste this
 * shell themselves.
 */
export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background pb-20 lg:pb-0 print:pb-0">
      {/* Navigation renders both the header and the fixed mobile tab bar, and neither belongs on
          paper. Hidden here rather than inside Navigation so the rule sits with the layout that
          also owns the tab bar's `pb-20` clearance, which has to go with it. */}
      <div className="print:hidden">
        <Navigation />
      </div>
      <main className="content-max section-x flex-1 py-6">
        <Outlet />
      </main>
    </div>
  );
}
